"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.darkTheme = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _styles = require("@mui/material/styles");
var defaultTheme = (0, _styles.createTheme)({
  palette: {
    mode: 'dark'
  }
});
var darkTheme = (0, _styles.createTheme)({
  name: 'dark',
  palette: (0, _objectSpread2.default)((0, _objectSpread2.default)({
    mode: 'light'
  }, defaultTheme.palette), {}, {
    primary: {
      main: '#9c27b0',
      light: '#d05ce3',
      dark: '#6a0080'
    },
    secondary: {
      main: '#00acc1',
      light: '#5ddef4',
      dark: '#007c91'
    },
    success: {
      main: '#66bb6a',
      light: '#98ee99',
      dark: '#338a3e'
    },
    info: {
      main: '#26a69a',
      light: '#64d8cb',
      dark: '#00766c'
    },
    error: {
      main: '#f44336',
      light: '#ff7961',
      dark: '#ba000d'
    },
    chartContainerBackground: defaultTheme.palette.background.paper,
    chartContainerShadow: 'none'
  }),
  transitions: (0, _objectSpread2.default)({}, defaultTheme.transitions),
  typography: {
    fontFamily: ['Roboto'].join(','),
    button: {
      textTransform: 'none'
    }
  },
  shape: {
    borderRadius: 0
  },
  components: {
    MuiFab: {
      styleOverrides: {
        root: {
          background: "linear-gradient(to bottom right, #00acc1, #007c91)"
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: function root(_ref) {
          var ownerState = _ref.ownerState;
          if (ownerState.component === 'header') {
            return (0, _defineProperty2.default)({
              background: "linear-gradient(to top left, #9c27b0, #6a0080)",
              top: 0,
              height: '56px',
              justifyContent: 'center'
            }, defaultTheme.breakpoints.down('sm'), {
              height: '56px'
            });
          } else if (ownerState.component === 'footer') {
            return (0, _defineProperty2.default)({
              background: "linear-gradient(to top left, #9c27b0, #6a0080)",
              top: 'auto',
              width: '100%',
              bottom: 0,
              textAlign: 'center',
              height: '56px'
            }, defaultTheme.breakpoints.down('sm'), {
              height: '56px'
            });
          }
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: function root(_ref4) {
          var ownerState = _ref4.ownerState;
          if (ownerState.className === 'footer') {
            return {
              justifyContent: 'center'
            };
          } else if (ownerState.className === 'header') {
            return {
              justifyContent: 'space-between',
              pr: 1,
              // FIXME: Somehow padding left is not working
              borderLeft: '8px solid transparent !important'
            };
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: function root(_ref5) {
          var ownerState = _ref5.ownerState;
          ownerState.size = 'large';
        }
      }
    },
    MuiMenu: {
      styleOverrides: {}
    },
    MuiList: {
      styleOverrides: {
        root: function root(_ref6) {
          var ownerState = _ref6.ownerState;
          if (ownerState.className === 'data-list') {
            return {
              disablePadding: false,
              marginBottom: '50px !important'
            };
          }
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: function root(_ref7) {
          var ownerState = _ref7.ownerState;
          if (ownerState.className === 'data-list-item') {
            return {
              display: 'list-item',
              minHeight: '50px',
              background: defaultTheme.palette.background.paper
            };
          } else {
            return {
              display: 'list-item',
              background: defaultTheme.palette.background.paper
            };
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: function root(_ref8) {
          var ownerState = _ref8.ownerState;
          if (ownerState.className === 'card-for-selection') {
            return {
              background: defaultTheme.palette.background.paper,
              boxShadow: 'none',
              overflowY: 'auto'
            };
          } else if (ownerState.className === 'card-for-list') {
            return {
              background: defaultTheme.palette.background.paper
            };
          } else if (ownerState.className === 'card-for-selection-title') {
            return {
              background: "linear-gradient(to bottom right, #00acc1, #007c91)",
              minHeight: '32px',
              display: 'flex',
              alignItems: 'center'
            };
          } else {
            return {
              background: defaultTheme.palette.background.paper
            };
          }
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingBottom: '16px !important'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {},
        filled: {
          background: "linear-gradient(180deg, #9c27b0, #6a0080)"
        },
        outlined: {
          border: "2px solid #6a0080"
        }
      }
    },
    MuiListItemButton: {
      defaultProps: {
        alignItems: 'center',
        divider: false,
        disableGutters: true
      }
    },
    MuiListItemText: {
      styleOverrides: {
        root: (0, _defineProperty2.default)({
          textAlign: 'left',
          marginTop: 1,
          marginBottom: 1
        }, defaultTheme.breakpoints.not('xs'), {
          textAlign: 'center'
        })
      }
    },
    MuiListItemIcon: {
      defaultProps: {}
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 'bold',
          color: defaultTheme.palette.text.primary
        },
        root: (0, _defineProperty2.default)({}, defaultTheme.breakpoints.only('xs'), {
          fontSize: '12px'
        })
      }
    },
    MuiTypography: {
      styleOverrides: {
        body1: (0, _defineProperty2.default)({}, defaultTheme.breakpoints.only('xs'), {
          fontSize: '12px'
        })
      }
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          display: 'list-item',
          paddingLeft: '8px',
          paddingRight: '8px',
          paddingTop: '4px',
          paddingBottom: '4px'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: function root(_ref9) {
          var ownerState = _ref9.ownerState;
          if (ownerState.className === 'chart-container') {
            var _ref10;
            return _ref10 = {}, (0, _defineProperty2.default)(_ref10, defaultTheme.breakpoints.up('md'), {
              height: '450px'
            }), (0, _defineProperty2.default)(_ref10, defaultTheme.breakpoints.up('sm'), {
              height: '400px'
            }), (0, _defineProperty2.default)(_ref10, defaultTheme.breakpoints.up('xs'), {
              height: '300px'
            }), _ref10;
          } else if (ownerState.className === 'filter-container') {
            ownerState.sx.background = "linear-gradient(to top left, #00acc1, #007c91)";
            ownerState.sx.minimumHeight = '32px';
            if (document.querySelector(".".concat(ownerState.className))) {
              document.querySelector(".".concat(ownerState.className)).children[0].style.justifyContent = 'space-between';
            }
          }
        }
      }
    }
  }
});
exports.darkTheme = darkTheme;